import { InjectionToken, Provider, Signal } from '@angular/core';

/** The app's feature flags by name, as its flag store holds them. */
export type SchemaFeatureFlags = Readonly<Record<string, boolean>>;

/**
 * What `hasFeatureFlag` and `hasNotFeatureFlag` read: the app's flags, or `undefined` while they are still loading, so
 * that neither form holds before they arrive. Optional — where no host provides it, no flag is on.
 *
 * A token rather than an import of the flag store, so schema core depends on neither NgRx nor the flag library; the
 * app that loads flags publishes them, the way `provideSchemaContext` publishes the context.
 */
export const SCHEMA_FEATURE_FLAGS = new InjectionToken<Signal<SchemaFeatureFlags | undefined>>('SCHEMA_FEATURE_FLAGS');

/** Publishes the flags a schema's conditions may name. A host provides it once, where its flags load. */
export function provideSchemaFeatureFlags(flags: () => Signal<SchemaFeatureFlags | undefined>): Provider {
  return { provide: SCHEMA_FEATURE_FLAGS, useFactory: flags };
}
